import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-uppercase text-center text-2xl" }, " Biên bản kiểm nghiệm sản phẩm, vật tư, hàng hóa ")
], -1)
const _hoisted_3 = { class: "container mt-5" }
const _hoisted_4 = { class: "row mb-5" }
const _hoisted_5 = {
  key: 0,
  class: "text-center text-lg"
}
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_8 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_9 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_10 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_11 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_12 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_13 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_14 = { class: "text-start m-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "row mt-5" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-10" }, null, -1)
const _hoisted_18 = { class: "col-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1)
const _hoisted_20 = { class: "phieu-nhap-kho-form-fields" }
const _hoisted_21 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_22 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_23 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_24 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_25 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_26 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_27 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_28 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_29 = {
  key: 0,
  class: "text-end"
}

import {
  buildPhieuNhapKhoCreatePayload,
  buildPhieuNhapKhoUpdatePayload,
  getChiTietPhieuNhapKhoParams,
  isPhieuNhapKhoUpdatePayloadEmpty,
  usePhieuNhapKhoFormMode,
  usePhieuNhapKhoUpdateContext,
} from "@/components/phieu-nhap-kho";
import { LoaiPhieuNhapEnum } from "@/core/enums/loaiPhieuNhap.enum";
import { setBreadcrumbLinks, setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { ref, onMounted, computed, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  IHopDongResponseBase,
  IKhoResponseBase,
  IVatTuBienBan,
  IVatTuBienBanKiemNghiemResponseBase,
  IVatTuPhieuNhapKho,
} from "@/core/interfaces/ApiResponses";
import { useLoading } from "@/core/hooks/use-loading";
import { KhoService } from "@/core/services/Kho.service";
import { useCreatingForm } from "@/core/hooks/use-creating-form";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import {
  getErrorMsg,
  getHoiDongBbkn,
  parseThanhPhanHoiDong,
  setHoiDongBbkn,
  swalErrNotification,
  swalNotification,
} from "@/core/helpers/utils";
import {
  formatDatePayload,
  getGlobalDefaultDate,
  useDateTime,
} from "@/core/hooks/use-date-time-hook";
import BaseLink from "@/components/shared/base-link/BaseLink.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import NguoiKiemNghiem, {
  type INguoiKiemNghiem,
} from "@/components/shared/nguoi-kiem-nghiem/NguoiKiemNghiem.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageContentSection from "@/layout/_shared/PageContentSection.vue";
import VatTuBienBanTable from "@/views/crafted/pages/bien-ban-kiem-nghiem/vat-tu-bien-ban-kiem-nghiem/VatTuBienBanTable.vue";
import useTaiKhoan from "@/core/hooks/useTaiKhoan";
import { AddVatTuItemsFor } from "@/core/enums/addVatTuItemsFor.enum";
import type { IVatTuDaChon } from "@/components/add-vat-tu-items/AddVatTuItems.vue";
import AddVatTuItems from "@/components/add-vat-tu-items/AddVatTuItems.vue";
import TaiKhoanSelectionV2 from "@/components/shared/tai-khoan-selection/TaiKhoanSelectionV2.vue";
import { useStore } from "vuex";
import { useAccount } from "@/core/hooks/use-account";
import { useBienBan } from "@/core/hooks/use-bien-ban-hook";
import { PhieuNhapKhoService } from "@/core/services/PhieuNhapKho.service";
import { HopDongService } from "@/core/services/HopDong.service";
import { DonViService } from "@/core/services/DonVi.service";
import type {
  PhieuNhapKhoVatTuLineInput,
  HopDongVatTuSelectionRow,
} from "@/types/phieu-nhap-kho";

interface VatTuBienBanTableExpose {
  items: IVatTuBienBan[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const { isCreating, formRef } = useCreatingForm();
const {
  updateCapabilities,
  canEditBbknHeaders,
  canEditChiTiet,
  canEditPhieuNhapHeaders,
  isFormLocked,
  setEditStateFromDetail,
} = usePhieuNhapKhoUpdateContext(isCreating);
const idKho = ref<number>(Number(route.query.idKho) || 0);
const idPhieuNhap = ref<number>(Number(route.params.id) || 0);
const idHopDong = ref<number>(Number(route.query.idHopDong) || 0);
const isPhieuNhapTheoHopDong = ref<boolean>(
  route.name?.toString() === "tao-moi-phieu-nhap-kho"
);
const loaiPhieu = ref<LoaiPhieuNhapEnum | null>(
  isPhieuNhapTheoHopDong.value
    ? LoaiPhieuNhapEnum.HOP_DONG_MUA_BAN
    : LoaiPhieuNhapEnum.TAM_NHAP
);

const { formConfig } = usePhieuNhapKhoFormMode(
  route,
  computed(() => ({
    loaiPhieu: loaiPhieu.value,
    isHopDong: isPhieuNhapTheoHopDong.value,
  }))
);

const pageHeading = computed(() => {
  if (formConfig.value.mode === "edit") {
    return isPhieuNhapTheoHopDong.value
      ? "Chỉnh sửa BBKN"
      : "Chỉnh sửa phiếu nhập khác";
  }

  return formConfig.value.pageTitle;
});

const { startLoading, endLoading } = useLoading();
const { ButtonsType, ButtonTypeColors } = useButtonCustom();
const { tkData, onSelectTaiKhoan, clearTaiKhoanData, setTkData } =
  useTaiKhoan();
const { currentUserData } = useAccount();
const { calculateSoLuongVatTuCan } = useBienBan();
const { moment } = useDateTime();
const idDonVi = currentUserData.value.departmentId;
const khoDetail = ref<IKhoResponseBase | null>(null);
const hopDongDetail = ref<IHopDongResponseBase | null>(null);
const khoItems = ref<IKhoResponseBase[]>();
const vatTuDangChonItems = ref<IVatTuPhieuNhapKho[]>([]);
const vatTuBienBanItems = ref<IVatTuBienBan[]>([]);
const soLuongCanArr = ref<number[]>([]);
const soPhieuNhap = ref<string | null>(null);
const tenDonVi = ref<string>("");
const isAddVatTuModalDisplay = ref<boolean>(false);
const buildDefaultHoiDong = (): INguoiKiemNghiem[] =>
  Array.from({ length: 4 }, (_, i) => ({
    thuTu: i + 1,
    hoTen: "",
    chucVu: "",
    thanhPhan: "",
  }));

/** Restore hội đồng from localStorage on create; edit loads from API. */
const resolveInitialHoiDong = (): INguoiKiemNghiem[] => {
  if (!isCreating.value) {
    return [];
  }

  const stored = getHoiDongBbkn();

  return stored.length > 0 ? stored : buildDefaultHoiDong();
};

const hoiDongKiemNghiem = ref<INguoiKiemNghiem[]>(resolveInitialHoiDong());

const showPageContent = computed<boolean>(() => {
  if (isPhieuNhapTheoHopDong.value) {
    return Boolean(hopDongDetail.value);
  }

  return Boolean(khoDetail.value);
});

const availableKhoItems = computed(() => [
  { label: "Chưa chọn", value: 0 },
  ...(khoItems.value ?? []).map((item) => ({
    value: item.id,
    label: item.ten_kho,
  })),
]);

const allowEditingDonGia = computed(
  () => Number(hopDongDetail.value?.loai_hop_dong) === 2 && canEditChiTiet.value
);

const resolveHopDongVatTuDonGia = (
  row: HopDongVatTuSelectionRow & {
    pivot?: { so_tien?: number; don_gia?: number };
  }
) =>
  Number(
    row.don_gia_hd ??
      row.don_gia ??
      row.pivot?.so_tien ??
      row.pivot?.don_gia ??
      0
  );

const selectedKho = computed<IKhoResponseBase | null>(() => {
  if (isCreating.value || !form.value.kho_id) {
    return null;
  }

  return (
    (khoItems.value ?? []).find((item) => item.id === form.value.kho_id) ?? null
  );
});

const mapVatTuPhieuNhapToBienBanRow = (
  vatTuItem: IVatTuPhieuNhapKho
): IVatTuBienBan => ({
  ...vatTuItem,
  so_luong_trong_bien_ban: +vatTuItem.pivot.so_luong,
  so_luong_can: 0,
  phuong_thuc: vatTuItem.pivot.phuong_thuc_kiem_nghiem ?? "",
  is_dat: (vatTuItem.pivot.ket_qua_kiem_nghiem ?? 1) === 1,
  so_luong_nhap_toi_da: 0,
  pivot: {
    id_hop_dong: 0,
    id_vat_tu: vatTuItem.id,
    so_luong: +vatTuItem.pivot.so_luong,
    so_tien: +vatTuItem.pivot.don_gia,
  },
});

const vatTuItemsDisplay = ref<IVatTuBienBan[]>([]);

const tamNhapVatTuTableRef = ref<VatTuBienBanTableExpose | null>(null);

const syncVatTuItemsDisplay = () => {
  vatTuItemsDisplay.value = vatTuDangChonItems.value.map(
    mapVatTuPhieuNhapToBienBanRow
  );
};

const syncTamNhapVatTuFromTable = () => {
  const tableItems = tamNhapVatTuTableRef.value?.items ?? [];

  tableItems.forEach((row) => {
    const item = vatTuDangChonItems.value.find((vatTu) => vatTu.id === row.id);

    if (!item) {
      return;
    }

    item.pivot.so_luong = +row.so_luong_trong_bien_ban;
    item.pivot.don_gia = +row.pivot.so_tien;
    item.don_gia = +row.pivot.so_tien;
    item.pivot.phuong_thuc_kiem_nghiem = row.phuong_thuc ?? "";
  });
};

const buildInvoiceFields = (): {
  so_hoa_don: string | null;
  ngay_hoa_don: string | null;
  nguoi_giao: string | null;
} => {
  const soHoaDon = form.value.so_hoa_don?.trim() || null;
  const formattedNgay = form.value.ngay_hoa_don
    ? formatDatePayload(form.value.ngay_hoa_don)
    : "";

  return {
    so_hoa_don: soHoaDon,
    ngay_hoa_don: formattedNgay || null,
    nguoi_giao: form.value.nguoi_giao?.trim() || null,
  };
};

const buildPhieuNhapHeadersForUpdate = () => {
  const invoiceFields = buildInvoiceFields();

  if (isPhieuNhapTheoHopDong.value) {
    return invoiceFields;
  }

  const headers: Record<string, string | null | undefined> = {
    ma_tk_co: tkData.value.maTaiKhoan,
    ten_tk_co: tkData.value.tenTaiKhoan,
    ...invoiceFields,
  };

  if (tkData.value.maChiTiet) {
    headers.ma_ct_co = tkData.value.maChiTiet;
  }

  return headers;
};

const form = ref({
  kho_id: idKho.value,
  ngay_bien_ban: getGlobalDefaultDate(),
  giam_doc: "",
  nguoi_giao: "",
  so_hoa_don: "",
  ngay_hoa_don: null as Date | null,
  y_kien: "",
});

const rules = computed(() => ({
  ...(isPhieuNhapTheoHopDong.value && {
    kho_id: [
      {
        type: "number",
        min: 1,
        message: "Phải chọn kho",
        trigger: "change",
      },
    ],
  }),
  giam_doc: [
    {
      required: true,
      message: "Bắt buộc phải nhập",
      trigger: "blur",
    },
  ],
  ngay_bien_ban: [
    {
      required: true,
      message: "Phải nhập ngày",
      trigger: "blur",
    },
  ],
  y_kien: [
    {
      validator: (_: unknown, value: string, cb: (error?: Error) => void) => {
        if (!value || value.trim() === "") {
          cb(new Error("Không được để trống"));
        } else {
          cb();
        }
      },
      trigger: "blur",
    },
  ],
}));

const loadHopDongVatTu = async () => {
  const query =
    !isCreating.value && idPhieuNhap.value
      ? { exclude_id_phieu_nhap: [idPhieuNhap.value] }
      : undefined;

  const { data: response } = await PhieuNhapKhoService.getHopDongVatTu(
    idHopDong.value,
    query
  );

  const raw = response.data;
  const rows: HopDongVatTuSelectionRow[] = Array.isArray(raw)
    ? raw
    : Array.isArray((raw as { data?: HopDongVatTuSelectionRow[] }).data)
    ? (raw as { data: HopDongVatTuSelectionRow[] }).data
    : [];

  vatTuBienBanItems.value = rows.map((row) => {
    const vatTuId = row.id_vat_tu ?? row.id;

    return {
      id: vatTuId,
      ma_vat_tu: row.ma_vat_tu,
      ten_vat_tu: row.ten_vat_tu,
      don_vi_tinh: row.don_vi_tinh,
      is_valid: row.is_valid,
      phuong_thuc: "",
      so_luong_trong_bien_ban: 0,
      so_luong_can: row.so_luong_con_lai,
      so_luong_nhap_toi_da: row.so_luong_con_lai,
      is_dat: true,
      pivot: {
        id_hop_dong: idHopDong.value,
        id_vat_tu: vatTuId,
        so_luong: +row.so_luong_hd,
        so_tien: resolveHopDongVatTuDonGia(row),
      },
    };
  });
};

const mergePhieuNhapVatTuFromDetail = (
  items: IVatTuBienBan[],
  vatTuDaNhapKho: IVatTuPhieuNhapKho[],
  bienBanVatTu?: IVatTuBienBanKiemNghiemResponseBase[]
): IVatTuBienBan[] => {
  const phieuById = new Map(vatTuDaNhapKho.map((v) => [v.id, v]));
  const bbknById = new Map((bienBanVatTu ?? []).map((v) => [v.id, v]));

  return items.map((item) => {
    const phieuLine = phieuById.get(item.id);

    if (!phieuLine) {
      return item;
    }

    const bbknLine = bbknById.get(item.id);

    return {
      ...item,
      so_luong_trong_bien_ban: +phieuLine.pivot.so_luong,
      phuong_thuc:
        bbknLine?.pivot.phuong_thuc_kiem_nghiem ??
        phieuLine.pivot.phuong_thuc_kiem_nghiem ??
        item.phuong_thuc,
      is_dat: bbknLine ? bbknLine.pivot.ket_qua_kiem_nghiem === 1 : item.is_dat,
      pivot: {
        ...item.pivot,
        so_tien: +(bbknLine?.pivot.don_gia ?? phieuLine.pivot.don_gia),
      },
    };
  });
};

const fetchKho = async () => {
  const {
    data: { data },
  } = await KhoService.fetchWarehouseDetailById(idKho.value.toString());

  khoDetail.value = data;
};

const fetchPhieuNhap = async () => {
  const {
    data: { data },
  } = await PhieuNhapKhoService.get(idPhieuNhap.value);

  setEditStateFromDetail(data);

  const {
    bien_ban_kiem_nghiem,
    so_hoa_don,
    ngay_hoa_don,
    nguoi_giao,
    ma_ct_co,
    ma_tk_co,
    vat_tu_nhap_kho,
    ten_tk_co,
  } = data;

  setTkData(ma_tk_co, "ma_tk");

  if (ma_ct_co) {
    setTkData(ma_ct_co, "ma_ct");
  }

  setTkData(ten_tk_co, "ten_tk");

  if (bien_ban_kiem_nghiem?.ten_giam_doc) {
    form.value.giam_doc = bien_ban_kiem_nghiem.ten_giam_doc;
  }

  form.value.so_hoa_don = so_hoa_don ?? "";
  form.value.ngay_hoa_don = ngay_hoa_don ? new Date(ngay_hoa_don) : null;
  form.value.nguoi_giao = nguoi_giao ?? "";
  form.value.y_kien = bien_ban_kiem_nghiem?.y_kien ?? "";

  if (bien_ban_kiem_nghiem?.ngay_bien_ban) {
    form.value.ngay_bien_ban = new Date(bien_ban_kiem_nghiem.ngay_bien_ban);
  }

  const bbknVatTuById = new Map(
    (bien_ban_kiem_nghiem?.vat_tu_bien_ban_kiem_nghiem ?? []).map((vatTu) => [
      vatTu.id,
      vatTu,
    ])
  );

  vatTuDangChonItems.value = vat_tu_nhap_kho.map((vatTu) => {
    const bbknLine = bbknVatTuById.get(vatTu.id);

    return {
      ...vatTu,
      don_gia: vatTu.pivot.don_gia,
      pivot: {
        ...vatTu.pivot,
        so_luong: +vatTu.pivot.so_luong,
        don_gia: +vatTu.pivot.don_gia,
        phuong_thuc_kiem_nghiem:
          bbknLine?.pivot.phuong_thuc_kiem_nghiem ??
          vatTu.pivot.phuong_thuc_kiem_nghiem ??
          "",
        ket_qua_kiem_nghiem:
          bbknLine?.pivot.ket_qua_kiem_nghiem ??
          vatTu.pivot.ket_qua_kiem_nghiem ??
          1,
      },
    };
  });

  syncVatTuItemsDisplay();

  const { members: parsedHoiDong, invalid } = parseThanhPhanHoiDong(
    bien_ban_kiem_nghiem?.thanh_phan_hoi_dong
  );

  if (invalid) {
    await swalNotification(
      "Dữ liệu thành phần hội đồng kiểm nghiệm không đúng định dạng, vui lòng kiểm tra lại",
      "error"
    );

    hoiDongKiemNghiem.value = buildDefaultHoiDong();

    return;
  }

  hoiDongKiemNghiem.value =
    parsedHoiDong.length > 0 ? parsedHoiDong : buildDefaultHoiDong();
};

const fetchKhoItems = async () => {
  const {
    data: {
      data: { data: response },
    },
  } = await KhoService.fetchAllWarehousesByDepartmentId(idDonVi);

  khoItems.value = [...response];
};

const fetchHopDong = async () => {
  const {
    data: { data },
  } = await HopDongService.fetchContractDetail(idHopDong.value);

  const {
    data: {
      data: { ten_don_vi },
    },
  } = await DonViService.fetchCurrentDepartmentById(idDonVi);

  tenDonVi.value = ten_don_vi;
  hopDongDetail.value = data;
  const { loai_hop_dong } = data;

  if (+loai_hop_dong === 1) {
    loaiPhieu.value = LoaiPhieuNhapEnum.HOP_DONG_MUA_BAN;
  } else {
    loaiPhieu.value = LoaiPhieuNhapEnum.HOP_DONG_DIEU_CHINH;
  }

  if (data.hop_dong_vat_tu) {
    soLuongCanArr.value = calculateSoLuongVatTuCan(data);
  }

  await loadHopDongVatTu();
};

const fetchPhieuNhapDetail = async () => {
  const {
    data: { data },
  } = await PhieuNhapKhoService.get(idPhieuNhap.value);

  setEditStateFromDetail(data);

  const {
    id_kho: fetchIdKho,
    bien_ban_kiem_nghiem: bienBanKiemNghiemData,
    so_phieu,
    so_hoa_don,
    ngay_hoa_don,
    nguoi_giao,
    vat_tu_nhap_kho: vatTuDaNhapKhoItems,
  } = data;

  form.value.kho_id = fetchIdKho;
  soPhieuNhap.value = so_phieu;
  form.value.so_hoa_don = so_hoa_don ?? "";
  form.value.ngay_hoa_don = ngay_hoa_don ? new Date(ngay_hoa_don) : null;
  form.value.nguoi_giao = nguoi_giao ?? "";

  vatTuBienBanItems.value = mergePhieuNhapVatTuFromDetail(
    vatTuBienBanItems.value,
    vatTuDaNhapKhoItems,
    bienBanKiemNghiemData?.vat_tu_bien_ban_kiem_nghiem
  );

  if (bienBanKiemNghiemData) {
    form.value.y_kien = bienBanKiemNghiemData.y_kien;
    form.value.giam_doc = bienBanKiemNghiemData.ten_giam_doc;
    form.value.ngay_bien_ban = new Date(bienBanKiemNghiemData.ngay_bien_ban);

    const { members: parsedHoiDong, invalid } = parseThanhPhanHoiDong(
      bienBanKiemNghiemData.thanh_phan_hoi_dong
    );

    if (invalid) {
      await swalNotification(
        "Dữ liệu thành phần hội đồng kiểm nghiệm không đúng định dạng, vui lòng kiểm tra lại",
        "error"
      );

      hoiDongKiemNghiem.value = buildDefaultHoiDong();
    } else {
      hoiDongKiemNghiem.value =
        parsedHoiDong.length > 0 ? parsedHoiDong : buildDefaultHoiDong();
    }
  }
};

const resolveEditContext = async () => {
  const {
    data: { data },
  } = await PhieuNhapKhoService.get(idPhieuNhap.value);

  setEditStateFromDetail(data);

  idKho.value = data.id_kho;
  isPhieuNhapTheoHopDong.value = Boolean(data.id_hop_dong);

  if (data.id_hop_dong) {
    idHopDong.value = data.id_hop_dong;

    if (data.hop_dong?.loai_hop_dong === 2) {
      loaiPhieu.value = LoaiPhieuNhapEnum.HOP_DONG_DIEU_CHINH;
    } else {
      loaiPhieu.value = LoaiPhieuNhapEnum.HOP_DONG_MUA_BAN;
    }
  } else {
    loaiPhieu.value = LoaiPhieuNhapEnum.TAM_NHAP;
  }
};

onMounted(async () => {
  if (!isCreating.value) {
    await resolveEditContext();
  }

  if (!isPhieuNhapTheoHopDong.value) {
    setBreadcrumbLinks([
      {
        text: "Kho",
        routeData: {
          name: "chi-tiet-kho",
          params: {
            id: idKho.value,
          },
        },
      },
      {
        text: isCreating.value
          ? formConfig.value.breadcrumbActionLabel
          : formConfig.value.breadcrumbActionLabel,
      },
    ]);
  } else {
    setBreadcrumbLinks([
      {
        text: "Hợp đồng",
        routeData: {
          name: "chi-tiet-hop-dong",
          params: {
            id: idHopDong.value,
          },
        },
      },
      {
        text: formConfig.value.breadcrumbActionLabel,
      },
    ]);
  }

  setCurrentPageTitle(pageHeading.value);

  try {
    if (!isPhieuNhapTheoHopDong.value) {
      await fetchKho();

      if (!isCreating.value) {
        await fetchPhieuNhap();
      }
    } else {
      await fetchHopDong();
      await fetchKhoItems();

      if (!isCreating.value) {
        await fetchPhieuNhapDetail();
      }
    }

    await endLoading();

    if (!isPhieuNhapTheoHopDong.value) {
      document.title = `${
        isCreating.value ? "Tạo" : "Chỉnh sửa"
      } - Phiếu nhập khác - ${
        khoDetail.value?.ten_kho || ""
      } - Đường sắt Hà Nội`;
    } else {
      document.title = isCreating.value
        ? `Biên bản kiểm nghiệm - Tạo mới - Hợp đồng ${hopDongDetail.value?.so_hop_dong} - Đường sắt Hà Nội`
        : `${soPhieuNhap.value} - Chỉnh sửa - Biên bản kiểm nghiệm - Hợp đồng ${hopDongDetail.value?.so_hop_dong} - Đường sắt Hà Nội`;
    }
  } catch (e) {
    await endLoading();

    await swalErrNotification(e, "Có lỗi khi lấy thông tin kho");
  }
});

const changePhuongThuc = ({
  index,
  value,
}: {
  index: number;
  value: string;
}) => {
  const displayItem = vatTuItemsDisplay.value[index];

  if (!displayItem) {
    return;
  }

  const vatTuItem = vatTuDangChonItems.value.find(
    (item) => item.id === displayItem.id
  );

  if (vatTuItem) {
    vatTuItem.pivot.phuong_thuc_kiem_nghiem = value;
  }
};

const handleSoLuongUpdate = ({
  items,
  id_vat_tu,
}: {
  items: IVatTuBienBan[];
  id_vat_tu: number;
}) => {
  const vatTuItemIndex = vatTuDangChonItems.value.findIndex(
    (vatTu) => vatTu.id === id_vat_tu
  );
  const updatedItem = items.find((item) => item.id === id_vat_tu);

  if (vatTuItemIndex >= 0 && updatedItem) {
    const newSoLuong = updatedItem.so_luong_trong_bien_ban;
    const item = vatTuDangChonItems.value[vatTuItemIndex];

    item.pivot.so_luong = +newSoLuong;
    item.pivot.don_gia = +updatedItem.pivot.so_tien;
    item.don_gia = +updatedItem.pivot.so_tien;
    item.pivot.phuong_thuc_kiem_nghiem = updatedItem.phuong_thuc ?? "";
  }
};

const handleTamNhapDonGiaUpdate = ({
  index,
  value,
}: {
  index: number;
  value: number;
}) => {
  const displayItem = vatTuItemsDisplay.value[index];

  if (!displayItem) {
    return;
  }

  const item = vatTuDangChonItems.value.find(
    (vatTu) => vatTu.id === displayItem.id
  );

  if (!item) {
    return;
  }

  item.pivot.don_gia = +value;
  item.don_gia = +value;
};

// Handlers cho luồng nhập theo hợp đồng (vatTuBienBanItems)
const onInputChange = ({ items }: { items: IVatTuBienBan[] }) => {
  vatTuBienBanItems.value = [...items];
};

const handleDonGiaUpdate = ({
  index,
  value,
}: {
  index: number;
  value: number;
}) => {
  const item = vatTuBienBanItems.value[index];

  if (!item || +item.pivot.so_tien === +value) {
    return;
  }

  item.pivot.so_tien = +value;
};

const onInputPhuongThuc = ({
  index,
  value,
}: {
  index: number;
  value: string;
}) => {
  vatTuBienBanItems.value[index].phuong_thuc = value;
};

const transformSelectingVatTuToVatTuPhieuNhap = (items: IVatTuDaChon[]) => {
  vatTuDangChonItems.value = items.map((item: IVatTuDaChon) => ({
    ...item,
    pivot: {
      don_gia: item.don_gia,
      id_phieu_nhap_kho: 0,
      id_vat_tu: item.id,
      so_luong: +item.so_luong,
      is_dat: 1,
      ket_qua_kiem_nghiem: 1,
      phuong_thuc_kiem_nghiem: "",
    },
  }));

  syncVatTuItemsDisplay();
};

const onAddedVatTuItems = ({
  vatTuDangChon: items,
}: {
  vatTuDangChon: IVatTuDaChon[];
}) => {
  isAddVatTuModalDisplay.value = false;
  transformSelectingVatTuToVatTuPhieuNhap(items);
};

const { commit } = useStore();

const getTamNhapChiTietLines = (): PhieuNhapKhoVatTuLineInput[] => {
  return vatTuDangChonItems.value
    .filter(({ pivot: { so_luong } }: IVatTuPhieuNhapKho) => +so_luong > 0)
    .map((vatTu: IVatTuPhieuNhapKho) => ({
      id: vatTu.id,
      so_luong: +vatTu.pivot.so_luong,
      don_gia: +vatTu.pivot.don_gia,
      ket_qua_kiem_nghiem: 1 as const,
      phuong_thuc_kiem_nghiem: vatTu.pivot.phuong_thuc_kiem_nghiem,
    }));
};

const getHopDongChiTietLines = (): PhieuNhapKhoVatTuLineInput[] => {
  return vatTuBienBanItems.value
    .filter((item) => item.so_luong_trong_bien_ban > 0)
    .map((item) => ({
      id: item.id,
      so_luong: item.so_luong_trong_bien_ban,
      so_tien: item.pivot.so_tien,
      ket_qua_kiem_nghiem: (item.is_dat ? 1 : 0) as 0 | 1,
      phuong_thuc_kiem_nghiem: item.phuong_thuc,
    }));
};

const buildBienBanFields = () => ({
  ngay_bien_ban: formatDatePayload(form.value.ngay_bien_ban),
  thanh_phan_hoi_dong: hoiDongKiemNghiem.value,
  y_kien: form.value.y_kien,
  ten_giam_doc: form.value.giam_doc,
});

const focusFirstSoLuongInput = async () => {
  await nextTick();

  const soLuongInputElement = document.querySelector(
    "#vat-tu-_so-luong-input_1 input"
  );

  if (soLuongInputElement) {
    (soLuongInputElement as HTMLInputElement).focus();
  }
};

const focusFirstFormError = async () => {
  await nextTick();

  const firstErrInput = document.querySelector(
    ".el-form-item.is-error input, .el-form-item.is-error textarea"
  );

  if (firstErrInput) {
    (firstErrInput as HTMLInputElement).focus();
    firstErrInput.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

const submitUnified = async () => {
  commit("ConfirmationDialogModule/closeDialog");

  if (isFormLocked.value) {
    await swalNotification(
      updateCapabilities.value.lockReason ?? "Phiếu nhập không thể chỉnh sửa",
      "error"
    );

    return;
  }

  if (!isPhieuNhapTheoHopDong.value) {
    syncTamNhapVatTuFromTable();
  }

  const chiTiet = isPhieuNhapTheoHopDong.value
    ? getHopDongChiTietLines()
    : getTamNhapChiTietLines();

  const requiresChiTiet =
    isCreating.value || updateCapabilities.value.canEditChiTiet;

  if (requiresChiTiet && chiTiet.length === 0) {
    await focusFirstSoLuongInput();

    await swalNotification(
      isPhieuNhapTheoHopDong.value
        ? "Bắt buộc phải nhập ít nhất một vật tư có số lượng lớn hơn 0"
        : "Bắt buộc phải nhập vật tư trong phiếu nhập và ít nhất phải có một vật tư có số lượng lớn hơn 0",
      "error"
    );

    return;
  }

  setHoiDongBbkn(hoiDongKiemNghiem.value);

  try {
    await startLoading();

    if (!isCreating.value) {
      const phieuNhapHeaders = updateCapabilities.value.canEditHeaders
        ? buildPhieuNhapHeadersForUpdate()
        : undefined;

      const payload = buildPhieuNhapKhoUpdatePayload({
        ...(phieuNhapHeaders && { phieuNhap: phieuNhapHeaders }),
        ...(updateCapabilities.value.canEditHeaders && {
          bienBanKiemNghiem: buildBienBanFields(),
        }),
        ...(updateCapabilities.value.canEditChiTiet && { chiTiet }),
      });

      if (isPhieuNhapKhoUpdatePayloadEmpty(payload)) {
        await endLoading();
        await swalNotification("Không có thay đổi nào để lưu", "error");

        return;
      }

      await PhieuNhapKhoService.update(idPhieuNhap.value, payload);

      await endLoading();
      await swalNotification(formConfig.value.submitUpdateMessage);

      await router.replace({
        name: "chi-tiet-phieu-nhap-kho",
        params: getChiTietPhieuNhapKhoParams(idPhieuNhap.value),
      });

      return;
    }

    const phieuNhap = isPhieuNhapTheoHopDong.value
      ? {
          id_hop_dong: idHopDong.value,
          id_kho: form.value.kho_id,
          ...buildInvoiceFields(),
        }
      : {
          id_hop_dong: 0,
          id_kho: idKho.value,
          ma_tk_co: tkData.value.maTaiKhoan,
          ...(tkData.value.maChiTiet && {
            ma_ct_co: tkData.value.maChiTiet,
          }),
          ten_tk_co: tkData.value.tenTaiKhoan,
          ...buildInvoiceFields(),
        };

    const payload = buildPhieuNhapKhoCreatePayload({
      phieuNhap,
      bienBanKiemNghiem: buildBienBanFields(),
      chiTiet,
    });

    const {
      data: { data },
    } = await PhieuNhapKhoService.create(payload);

    await endLoading();
    await swalNotification(formConfig.value.submitCreateMessage);

    await router.replace({
      name: "chi-tiet-phieu-nhap-kho",
      params: getChiTietPhieuNhapKhoParams(data.id),
    });
  } catch (e) {
    await endLoading();

    const msg = (e as { response?: { data?: { data?: { msg?: string } } } })
      .response?.data?.data?.msg;

    if (
      msg ===
        "Dữ liệu biên bản kiểm nghiệm không có dữ liệu. Vui lòng kiểm tra lại!" ||
      msg === "Số lượng bắt buộc nhập" ||
      msg === "Danh sách vật tư (chiTiet) không được để trống"
    ) {
      await focusFirstSoLuongInput();
    }

    await swalNotification(
      getErrorMsg(
        e,
        isPhieuNhapTheoHopDong.value
          ? "Có lỗi, không tạo được biên bản"
          : "Có lỗi xảy ra khi lưu phiếu nhập"
      ),
      "error"
    );
  }
};

const onSubmit = async () => {
  if (
    !isPhieuNhapTheoHopDong.value &&
    (!tkData.value.maTaiKhoan || !tkData.value.tenTaiKhoan)
  ) {
    await nextTick();

    const taiKhoanInput = document.querySelector(
      "#tai-khoan-selection_tai-khoan"
    );

    if (taiKhoanInput) {
      (taiKhoanInput as HTMLInputElement).focus();
    }

    await swalNotification("Bắt buộc phải nhập thông tin tài khoản", "error");

    return;
  }

  if (!formRef.value) {
    return;
  }

  const formInstance = formRef.value as unknown as {
    validate: (callback: (valid: boolean) => void) => void;
  };

  formInstance.validate(async (valid: boolean) => {
    if (!valid) {
      await focusFirstFormError();

      return false;
    }

    if (isPhieuNhapTheoHopDong.value) {
      commit("ConfirmationDialogModule/setDialog", {
        title: isCreating.value
          ? "Xác nhận"
          : `Phiếu nhập số ${soPhieuNhap.value} (HĐ số ${hopDongDetail.value?.so_hop_dong})`,
        message: isCreating.value
          ? formConfig.value.confirmCreateTitle
          : formConfig.value.confirmUpdateTitle,
        cancelText: "Hủy",
        onConfirm: submitUnified,
      });

      return;
    }

    commit("ConfirmationDialogModule/setDialog", {
      title: "Xác nhận",
      message: isCreating.value
        ? formConfig.value.confirmCreateTitle
        : formConfig.value.confirmUpdateTitle,
      cancelText: "Hủy",
      onConfirm: submitUnified,
    });
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AddVatTuItems, {
      "is-modal-open": isAddVatTuModalDisplay.value,
      "use-for": _unref(AddVatTuItemsFor).PHIEU_NHAP_LE,
      "vat-tu-da-chon-items": vatTuDangChonItems.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isAddVatTuModalDisplay.value = false)),
      onAdded: onAddedVatTuItems
    }, null, 8, ["is-modal-open", "use-for", "vat-tu-da-chon-items"]),
    _createVNode(PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(PageContentSection, { "always-expanded": true }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(pageHeading.value), 1)
          ]),
          default: _withCtx(() => [
            (showPageContent.value)
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  ref_key: "formRef",
                  ref: formRef,
                  model: form.value,
                  rules: rules.value,
                  onSubmit: _withModifiers(onSubmit, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    (!_unref(isCreating) && _unref(updateCapabilities).lockReason)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 0,
                          class: "mb-4",
                          closable: false,
                          "show-icon": "",
                          title: _unref(updateCapabilities).lockReason,
                          type: "warning"
                        }, null, 8, ["title"]))
                      : (!_unref(isCreating) && _unref(updateCapabilities).isCompletedRestriction)
                        ? (_openBlock(), _createBlock(_component_el_alert, {
                            key: 1,
                            class: "mb-4",
                            closable: false,
                            "show-icon": "",
                            title: "Phiếu đã hoàn thành — chỉ có thể cập nhật 1 số thông tin, không thể thay đổi vật tư.",
                            type: "info"
                          }))
                        : _createCommentVNode("", true),
                    (isPhieuNhapTheoHopDong.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (hopDongDetail.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _hoisted_2,
                                _createElementVNode("div", _hoisted_3, [
                                  _createElementVNode("div", _hoisted_4, [
                                    (!_unref(isCreating) && soPhieuNhap.value && idPhieuNhap.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                          _createElementVNode("p", _hoisted_6, [
                                            _createTextVNode(" Phiếu nhập số "),
                                            _createVNode(BaseLink, {
                                              isOpenInNewTab: "",
                                              to: {
                        name: 'chi-tiet-phieu-nhap-kho',
                        params: _unref(getChiTietPhieuNhapKhoParams)(idPhieuNhap.value),
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(soPhieuNhap.value), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["to"]),
                                            _createTextVNode(" thuộc hợp đồng số "),
                                            _createVNode(BaseLink, {
                                              isOpenInNewTab: "",
                                              to: {
                        name: 'chi-tiet-hop-dong',
                        params: { id: hopDongDetail.value.id },
                      }
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(hopDongDetail.value.so_hop_dong), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["to"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createVNode(DivRow, { "additional-class": "mb-3 g-3 mt-1" }, {
                                    default: _withCtx(() => [
                                      _createVNode(DivCol, {
                                        "additional-class": "pb-2",
                                        cols: 3
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_7, [
                                            _createVNode(LabelCustom, {
                                              "is-bolder": true,
                                              "is-required": _unref(isCreating)
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Kho ")
                                              ]),
                                              _: 1
                                            }, 8, ["is-required"]),
                                            (_unref(isCreating))
                                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                                  key: 0,
                                                  class: "mb-0 w-100",
                                                  prop: "kho_id"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_select, {
                                                      id: "kho-select_input",
                                                      modelValue: form.value.kho_id,
                                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.kho_id) = $event)),
                                                      class: "w-100",
                                                      name: "kho_id",
                                                      placeholder: "Chọn kho",
                                                      filterable: ""
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableKhoItems.value, (option) => {
                                                          return (_openBlock(), _createBlock(_component_el_option, {
                                                            key: option.value,
                                                            label: option.label,
                                                            value: option.value
                                                          }, null, 8, ["label", "value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }))
                                              : (selectedKho.value)
                                                ? (_openBlock(), _createBlock(BaseLink, {
                                                    key: 1,
                                                    isOpenInNewTab: "",
                                                    to: {
                        name: 'chi-tiet-kho',
                        params: { id: selectedKho.value.id },
                      }
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(selectedKho.value?.ten_kho), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["to"]))
                                                : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(DivCol, {
                                        "additional-class": "pb-2",
                                        cols: 3
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_8, [
                                            _createVNode(LabelCustom, { "is-bolder": true }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Ngày")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_form_item, {
                                              class: "mb-0 w-100",
                                              prop: "ngay_bien_ban"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_date_picker, {
                                                  modelValue: form.value.ngay_bien_ban,
                                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.ngay_bien_ban) = $event)),
                                                  class: "w-100",
                                                  disabled: !_unref(canEditBbknHeaders),
                                                  format: "DD/MM/YYYY",
                                                  name: "ngay_bien_ban",
                                                  placeholder: "Chọn ngày"
                                                }, null, 8, ["modelValue", "disabled"])
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(DivCol, {
                                        "additional-class": "pb-2",
                                        cols: 3
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_9, [
                                            _createVNode(LabelCustom, {
                                              "is-bolder": true,
                                              "is-required": true
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Giám đốc ")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_form_item, {
                                              class: "mb-0 w-100",
                                              prop: "giam_doc"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: form.value.giam_doc,
                                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.giam_doc) = $event)),
                                                  disabled: !_unref(canEditBbknHeaders),
                                                  name: "giam_doc",
                                                  placeholder: "Mời nhập tên"
                                                }, null, 8, ["modelValue", "disabled"])
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(DivCol, {
                                        "additional-class": "pb-2",
                                        cols: 3
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_10, [
                                            _createVNode(LabelCustom, { "is-bolder": true }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Họ & tên người giao ")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_input, {
                                              modelValue: form.value.nguoi_giao,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.nguoi_giao) = $event)),
                                              class: "w-100",
                                              disabled: !_unref(canEditPhieuNhapHeaders),
                                              name: "nguoi_giao",
                                              placeholder: "Mời nhập tên"
                                            }, null, 8, ["modelValue", "disabled"])
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(DivRow, { "additional-class": "mb-3 g-3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(DivCol, {
                                        "additional-class": "pb-2",
                                        cols: 3
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_11, [
                                            _createVNode(LabelCustom, { "is-bolder": true }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Số hóa đơn")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_input, {
                                              modelValue: form.value.so_hoa_don,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.so_hoa_don) = $event)),
                                              class: "w-100",
                                              disabled: !_unref(canEditPhieuNhapHeaders)
                                            }, null, 8, ["modelValue", "disabled"])
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(DivCol, {
                                        "additional-class": "pb-2",
                                        cols: 3
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_12, [
                                            _createVNode(LabelCustom, { "is-bolder": true }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Ngày hóa đơn")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: form.value.ngay_hoa_don,
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.ngay_hoa_don) = $event)),
                                              "allow-before-global-min": "",
                                              class: "w-100",
                                              disabled: !_unref(canEditPhieuNhapHeaders),
                                              format: "DD/MM/YYYY",
                                              placeholder: "Chọn ngày"
                                            }, null, 8, ["modelValue", "disabled"])
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(DivCol, {
                                        "additional-class": "pb-2",
                                        cols: 6
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_13, [
                                            _createVNode(LabelCustom, {
                                              "is-bolder": true,
                                              "is-required": true
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" Ý kiến HĐKN ")
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_el_form_item, {
                                              class: "mb-0 w-100",
                                              prop: "y_kien"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: form.value.y_kien,
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.y_kien) = $event)),
                                                  disabled: !_unref(canEditBbknHeaders),
                                                  placeholder: "Mời nhập ý kiến",
                                                  autosize: { minRows: 1 },
                                                  resize: "none",
                                                  type: "textarea"
                                                }, null, 8, ["modelValue", "disabled"])
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(NguoiKiemNghiem, {
                                    "model-value": hoiDongKiemNghiem.value,
                                    "giam-doc-name": form.value.giam_doc,
                                    "onUpdate:giamDocName": _cache[8] || (_cache[8] = ($event: any) => ((form.value.giam_doc) = $event)),
                                    "is-editable": _unref(canEditBbknHeaders),
                                    "show-giam-doc-input": false,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (hoiDongKiemNghiem.value = $event))
                                  }, null, 8, ["model-value", "giam-doc-name", "is-editable"]),
                                  _createElementVNode("h5", _hoisted_14, [
                                    _createTextVNode(" Đã tiến hành kiểm nghiệm các loại vật tư theo hợp đồng số "),
                                    _createElementVNode("strong", null, _toDisplayString(hopDongDetail.value?.so_hop_dong), 1),
                                    _createTextVNode(" ngày "),
                                    _createElementVNode("strong", null, _toDisplayString(_unref(moment)(hopDongDetail.value?.ngay_ky).format("DD/MM/YYYY")), 1),
                                    _createTextVNode(" như sau: ")
                                  ])
                                ]),
                                (vatTuBienBanItems.value.length)
                                  ? (_openBlock(), _createBlock(VatTuBienBanTable, {
                                      key: 0,
                                      "allow-editing-don-gia": allowEditingDonGia.value,
                                      "for-phieu-nhap-le": false,
                                      "is-editable": _unref(canEditChiTiet),
                                      "vat-tu-items": vatTuBienBanItems.value,
                                      onChangeDonGia: handleDonGiaUpdate,
                                      onOnChange: onInputChange,
                                      onOnChangePhuongThuc: onInputPhuongThuc
                                    }, null, 8, ["allow-editing-don-gia", "is-editable", "vat-tu-items"]))
                                  : _createCommentVNode("", true),
                                _hoisted_15,
                                _createElementVNode("div", _hoisted_16, [
                                  _hoisted_17,
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(ButtonCustom, {
                                      "button-type": _unref(ButtonsType).SAVE,
                                      "color-type": _unref(ButtonTypeColors).SUCCESS,
                                      "is-disabled": _unref(isFormLocked),
                                      onClick: onSubmit
                                    }, {
                                      "button-label": _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(isCreating) ? "Tạo B/b" : "Lưu chỉnh sửa"), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["button-type", "color-type", "is-disabled"])
                                  ]),
                                  _hoisted_19
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(DivRow, { "additional-class": "mb-3 g-3" }, {
                              default: _withCtx(() => [
                                _createVNode(DivCol, {
                                  "additional-class": "pb-2",
                                  cols: 3
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_21, [
                                      _createVNode(LabelCustom, { "is-bolder": true }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Kho")
                                        ]),
                                        _: 1
                                      }),
                                      (khoDetail.value)
                                        ? (_openBlock(), _createBlock(BaseLink, {
                                            key: 0,
                                            to: {
                      name: 'chi-tiet-kho',
                      params: {
                        id: khoDetail.value.id,
                      },
                    }
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(khoDetail.value.ten_kho), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["to"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(DivCol, {
                                  "additional-class": "pb-2",
                                  cols: 3
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(LabelCustom, { "is-bolder": true }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Ngày biên bản")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, {
                                        class: "w-100 mb-0",
                                        prop: "ngay_bien_ban"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_date_picker, {
                                            modelValue: form.value.ngay_bien_ban,
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.ngay_bien_ban) = $event)),
                                            class: "w-100",
                                            format: "DD/MM/YYYY",
                                            name: "ngay_bien_ban",
                                            placeholder: "Chọn ngày",
                                            onFocus: _cache[11] || (_cache[11] = ($event: any) => ($event.target.select()))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(DivCol, {
                                  "additional-class": "pb-2",
                                  cols: 3
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_23, [
                                      _createVNode(LabelCustom, { "is-bolder": true }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Số hóa đơn")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_input, {
                                        modelValue: form.value.so_hoa_don,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.so_hoa_don) = $event)),
                                        class: "w-100",
                                        disabled: !_unref(canEditPhieuNhapHeaders)
                                      }, null, 8, ["modelValue", "disabled"])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(DivCol, {
                                  "additional-class": "pb-2",
                                  cols: 3
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_24, [
                                      _createVNode(LabelCustom, { "is-bolder": true }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Ngày hóa đơn")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_date_picker, {
                                        modelValue: form.value.ngay_hoa_don,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.ngay_hoa_don) = $event)),
                                        "allow-before-global-min": "",
                                        class: "w-100",
                                        disabled: !_unref(canEditPhieuNhapHeaders),
                                        format: "DD/MM/YYYY",
                                        placeholder: "Chọn ngày"
                                      }, null, 8, ["modelValue", "disabled"])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(DivRow, { "additional-class": "mb-3 g-3" }, {
                              default: _withCtx(() => [
                                _createVNode(DivCol, {
                                  "additional-class": "pb-2",
                                  cols: 3
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createVNode(LabelCustom, { "is-bolder": true }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Họ & tên người giao ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_input, {
                                        modelValue: form.value.nguoi_giao,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.nguoi_giao) = $event)),
                                        class: "w-100",
                                        disabled: !_unref(canEditPhieuNhapHeaders),
                                        name: "nguoi_giao",
                                        placeholder: "Mời nhập tên"
                                      }, null, 8, ["modelValue", "disabled"])
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(DivCol, {
                                  "additional-class": "pb-2",
                                  cols: 3
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_26, [
                                      _createVNode(LabelCustom, {
                                        "is-bolder": true,
                                        "is-required": true
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Giám đốc ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, {
                                        class: "mb-0 w-100",
                                        prop: "giam_doc"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: form.value.giam_doc,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.giam_doc) = $event)),
                                            disabled: !_unref(canEditPhieuNhapHeaders),
                                            name: "giam_doc",
                                            placeholder: "Mời nhập tên"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(DivCol, {
                                  "additional-class": "pb-2",
                                  cols: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createVNode(LabelCustom, {
                                        "is-bolder": true,
                                        "is-required": true
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Ý kiến HĐKN ")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_form_item, {
                                        class: "mb-0 w-100",
                                        prop: "y_kien"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            modelValue: form.value.y_kien,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.y_kien) = $event)),
                                            disabled: !_unref(canEditPhieuNhapHeaders),
                                            placeholder: "Mời nhập ý kiến",
                                            autosize: { minRows: 1 },
                                            resize: "none",
                                            type: "textarea"
                                          }, null, 8, ["modelValue", "disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(DivRow, { "additional-class": "mb-3 g-3" }, {
                              default: _withCtx(() => [
                                _createVNode(DivCol, {
                                  "additional-class": "pb-2",
                                  cols: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createVNode(LabelCustom, { "is-bolder": true }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Tài khoản kế toán")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(TaiKhoanSelectionV2, {
                                        class: "w-100",
                                        "read-only": !_unref(canEditPhieuNhapHeaders),
                                        "ma-tai-khoan-prop": _unref(tkData).maTaiKhoan,
                                        "ma-chi-tiet-prop": _unref(tkData).maChiTiet ? _unref(tkData).maChiTiet : undefined,
                                        "ten-tai-khoan-prop": _unref(tkData).tenTaiKhoan,
                                        onOnClear: _unref(clearTaiKhoanData),
                                        onOnSelect: _unref(onSelectTaiKhoan)
                                      }, null, 8, ["read-only", "ma-tai-khoan-prop", "ma-chi-tiet-prop", "ten-tai-khoan-prop", "onOnClear", "onOnSelect"])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(NguoiKiemNghiem, {
                            "model-value": hoiDongKiemNghiem.value,
                            "giam-doc-name": form.value.giam_doc,
                            "onUpdate:giamDocName": _cache[17] || (_cache[17] = ($event: any) => ((form.value.giam_doc) = $event)),
                            "is-editable": _unref(canEditBbknHeaders),
                            "show-giam-doc-input": false,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (hoiDongKiemNghiem.value = $event))
                          }, null, 8, ["model-value", "giam-doc-name", "is-editable"]),
                          (_unref(canEditChiTiet))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createVNode(ButtonCustom, {
                                  "button-type": _unref(ButtonsType).ADD,
                                  "color-type": _unref(ButtonTypeColors).SUCCESS,
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (isAddVatTuModalDisplay.value = true))
                                }, {
                                  "button-label": _withCtx(() => [
                                    _createTextVNode("Thêm hoặc xoá vật tư")
                                  ]),
                                  _: 1
                                }, 8, ["button-type", "color-type"])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(VatTuBienBanTable, {
                            ref_key: "tamNhapVatTuTableRef",
                            ref: tamNhapVatTuTableRef,
                            "allow-editing-don-gia": _unref(canEditChiTiet),
                            "for-phieu-nhap-le": true,
                            "is-editable": _unref(canEditChiTiet),
                            "vat-tu-items": vatTuItemsDisplay.value,
                            onChangeDonGia: handleTamNhapDonGiaUpdate,
                            onOnChangePhuongThuc: changePhuongThuc,
                            onOnChange: _cache[20] || (_cache[20] = (payload) => handleSoLuongUpdate(payload))
                          }, null, 8, ["allow-editing-don-gia", "is-editable", "vat-tu-items"]),
                          _createVNode(DivRow, { "additional-class": "mb-5" }, {
                            default: _withCtx(() => [
                              _createVNode(DivCol, { cols: 10 }),
                              _createVNode(DivCol, {
                                cols: 2,
                                style: {"text-align":"end"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(ButtonCustom, {
                                    "button-type": _unref(ButtonsType).SAVE,
                                    "color-type": _unref(ButtonTypeColors).SUCCESS,
                                    "is-disabled": _unref(isFormLocked),
                                    "tooltip-message": "",
                                    onClick: onSubmit
                                  }, {
                                    "button-label": _withCtx(() => [
                                      _createTextVNode("Lưu")
                                    ]),
                                    _: 1
                                  }, 8, ["button-type", "color-type", "is-disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["model", "rules"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})